import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import logo from "@/assets/seafarer - logo.png";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <img 
              src={logo} 
              alt="Seafarers United Logo" 
              className="h-16 mb-4" 
            />
            <p className="text-gray-300 mb-4">
              The October Seafarers United Land & Housing Federation is an inclusive platform that enables 
              fishermen to share ideas and establish sustainable business ecosystems.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                <Facebook size={20} />
                <span className="sr-only">Facebook</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                <Twitter size={20} />
                <span className="sr-only">Twitter</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                <Linkedin size={20} />
                <span className="sr-only">LinkedIn</span>
              </a>
              <a href="#" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                <Instagram size={20} />
                <span className="sr-only">Instagram</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-seafarer-orange transition-colors">Home</Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-seafarer-orange transition-colors">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-seafarer-orange transition-colors">Services</Link>
              </li>
              <li>
                <Link to="/projects" className="text-gray-300 hover:text-seafarer-orange transition-colors">Projects</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services" className="text-gray-300 hover:text-seafarer-orange transition-colors">Property Development</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-seafarer-orange transition-colors">Project Management</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-seafarer-orange transition-colors">Building Design</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-seafarer-orange transition-colors">Property Management</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-seafarer-orange transition-colors">Land Development</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xl font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="mr-2 h-5 w-5 text-seafarer-orange mt-1" />
                <span className="text-gray-300">
                  CBD, 5th Road<br />
                  Walvis Bay, ERF 25<br />
                  Namibia
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="mr-2 h-5 w-5 text-seafarer-orange" />
                <a href="tel:+264-64-221-787" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                  +264 64 221 787
                </a>
              </li>
              <li className="flex items-center">
                <Phone className="mr-2 h-5 w-5 text-seafarer-orange" />
                <a href="tel:+264-81-143-7833" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                +26481 143 7833
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="mr-2 h-5 w-5 text-seafarer-orange" />
                <a href="mailto:octoberseafarersgreenvally@gmail.com" className="text-gray-300 hover:text-seafarer-orange transition-colors">
                  octoberseafarersgreenvally@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 text-center text-gray-400">
          <p>© {year} October Seafarers United Land & Housing Federation. All rights reserved.</p>
          <p className="mt-2 text-sm">
            Designed and hosted by{' '}
            <a 
              href="https://spybitech.com.na" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-seafarer-orange hover:text-orange-400 transition-colors"
            >
              spybitech.com.na
            </a>{' '}
            Spybitech Investment CC
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
